import React from 'react'
import { Radio as MuiRadio, useTheme } from '@mui/material'
import { FULL_OPACITY } from 'shared/constants'
import { RadioButtonEmptyIcon, RadioButtonFilledIcon } from '../Icon'
import { Label, ControlLabel } from './styles'
import type { RadioProps } from './types'

const Radio: React.FC<RadioProps> = (props) => {
  const { value, label, labelPlacement, error } = props
  const { palette } = useTheme()

  return (
    <ControlLabel
      value={value}
      control={
        <MuiRadio
          icon={<RadioButtonEmptyIcon color={palette.text.primary} />}
          checkedIcon={<RadioButtonFilledIcon fillOpacity={FULL_OPACITY} />}
          {...{ ...props, error: undefined }}
        />
      }
      label={
        <Label color={error ? 'error' : 'default'} variant="body1">
          {label}
        </Label>
      }
      labelPlacement={labelPlacement}
    />
  )
}

export default Radio
